import yup from "../../../../../../../utils/yup-extended";
import {isNonEu} from "../../../../../../../utils/bank";
import {ACCOUNT_NUMBER_PATTERNS, hasBankBranch} from "../utils";

const accountDetailsFormSchema = yup.object().shape({
  countryCode: yup.string().required("Please select your country"),
  bankCode: yup.string().when("countryCode", {
    is: (countryCode: string) =>
      isNonEu.includes(countryCode) || hasBankBranch.includes(countryCode),
    then: (schema) => schema.required("Please select your bank"),
    otherwise: (schema) => schema,
  }),
  branchCode: yup.string().when("countryCode", {
    is: (countryCode: string) => hasBankBranch.includes(countryCode),
    then: (schema) => schema.required("Branch is required for the selected country."),
    otherwise: (schema) => schema,
  }),
  accountNumber: yup.string().when("countryCode", {
    is: (countryCode: string) =>
      isNonEu.includes(countryCode) || hasBankBranch.includes(countryCode),
    then: (schema) =>
      schema
        .required("Please input your account number")
        .test("accountNumberFormat", "Invalid format", function (value, context) {
          const country = context.parent.countryCode;
          if (!value || !country) return true;

          const pattern =
            ACCOUNT_NUMBER_PATTERNS[country as keyof typeof ACCOUNT_NUMBER_PATTERNS];
          if (!pattern) return true; // No specific validation for this country

          return pattern.test(value);
        })
        .transform((value) => value?.replace(/\D/g, "")),
    otherwise: (schema) => schema,
  }),
});

export {accountDetailsFormSchema};
